import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { RootPath } from "@/App/Equities/mobile/paths"
import { useRouteMatch } from "@/App/Equities/shared/utils"
import {
  BottomNavigation,
  BottomNavigationTab,
} from "@/components/BottomNavigation"

export const Navigation = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const EQUITIES_TABS: BottomNavigationTab[] = [
    { key: RootPath.trade, icon: "eye", label: t("navigation.equities.trade") },
    {
      key: RootPath.positions,
      icon: "trend",
      label: t("navigation.equities.positions"),
    },
    {
      key: RootPath.orderHistory,
      icon: "frame",
      label: t("navigation.equities.orders"),
    },
  ]

  const currentRoute = useRouteMatch(EQUITIES_TABS.map((tab) => tab.key))

  if (currentRoute == null) {
    return null
  }

  return (
    <BottomNavigation
      tabs={EQUITIES_TABS}
      activeTab={currentRoute}
      onTabChange={(key) => navigate(key)}
    />
  )
}
